import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-selector-unidad-inspeccion-superficie',
    templateUrl: './selector-unidad-inspeccion-superficie.component.html',
    styleUrls: ['./selector-unidad-inspeccion-superficie.component.scss'],
})
export class SelectorUnidadInspeccionSuperficieComponent {
    @Input() superficieUI: number = 0;
    @Input() superficieAcumulada: number = 0;

    isCollapsed = false;

    getBgProgress(): Object {
        return this.superficieAcumulada > this.superficieUI ? { 'bg-danger': true } : { 'bg-success': true };
    }

    get porcentajeCultivado(): number {
        return Math.round((this.superficieAcumulada * 100) / this.superficieUI);
    }
}
